<template>
<div class="mb-1 Comments">
  <CommentsList 
    :comments="comments"
    @submitComment="submitComment($event)" />
  <div 
    v-if="isCanAdd"
    class="Comments__form">
    <CommentForm @submitComment="submitComment($event)"/>
  </div>
</div>
</template>
<script>
  import CommentsList from './CommentsList';
  import CommentForm from './CommentForm';

  export default {
    components: {
      CommentsList,
      CommentForm
    },
    props: {
      comments: {
        type: Array,
        required: true,
        default: () => []
      },
      isCanAdd: {
        type: Boolean,
        default: true
      },
    },
    methods: {
      submitComment(comment) {
        this.$emit('submitComment', comment);
      }
    }
  }
</script>
<style lang="scss">
.Comments {
  &__form {
    margin-top: 30px;
  }
}
</style>
